<template lang="pug">
pr-wrapper.d-flex.align-items-end(fs, bg, bgo=".2", v-if="hasWeather")
  .weather.w-100.h-100
    .header.pl-5.pt-5(v-nv:scope="'weather-change'", data-down="weather", data-left="weather", @nv-back="goHome")
      .header-wrapper.ml-3
        pr-text(size="xlarge", weight="bold") {{ weather.slug }}
        pr-text(size="medium")
          moment.small(format="dddd, DD MMMM", date, :live="!day", :value="displayDate") 
      pr-button.change.background(v-if="!hasOnlyOne", v-nv.current, @nv-enter="citySelector()")
        icon.fa-2x(:icon="'map-marker-alt'")
    .content.flex-grow-1.pl-5.d-flex.align-items-center
      .content-wrapper.ml-3
        pr-text(size="xlarge") {{ $t(current.description) }}
        .temp.d-flex.align-items-center
          pr-text.current(v-if="!day", size="medium", weight="bold") {{ current.temp }}{{ weather.icon }}
          pr-text.max(v-if="day", size="medium", weight="bold") {{ current.max }} /
          pr-text.min.ml-3(v-if="day", weight="semibold") {{ current.min }} {{ weather.icon }}

    pr-wrapper.footer(bg="overlayFrom", bgd="-90", bgo=".8")
      .weathers.pb-4.px-5(v-nv:scope="'weather'", data-up="weather-change", @nv-back="goHome")
        .day.background(v-nv, v-for="(day, index) in forecast", :key="day.date", :id="`day${index}`", :data-id="index", @nv-focus="focused")
          pr-wrapper.day-name(bg, bgo=".5") {{ $moment(day.date).calendar(null, days_) }}
          .day-icon
            icon.fa-5x.py-4(:icon="day.icon") 
          .day-degrees
            pr-text.max(size="medium", weight="bold") {{ day.max }} /
            pr-text.min.ml-2(weight="semibold") {{ day.min }} {{ weather.icon }}
          imagec(covered, vertical, :src="!index ? current.image : day.image", small-placeholder)
</template>

<script>
export default {
  name: "weather",
  data() {
    return {
      active: null,
      day: null
    }
  },
  computed: {
    weather() {
      return this.$store.state.rss.weathers[this.active] || {}
    },
    forecast() {
      return this.weather?.forecast || []
    },
    current() {
      if (this.day === 0) return this.weather?.current
      else if (this.day > 0) return this.weather?.forecast[this.day]
      else return {}
    },
    isDirty() {
      return this.$store.state.rss.weather?.current.isDirty || false
    },
    hasOnlyOne() {
      return this.$store.state.rss.weathers.length === 1
    },
    hasWeather() {
      return this.$store.state.rss.weathers.length
    },
    displayDate() {
      return this.day > 0 ? this.forecast[this.day]?.date || "" : ""
    },
    days_() {
      return {
        lastWeek: "dddd",
        lastDay: `[${this.$t("Yesterday")}]`,
        sameDay: `[${this.$t("Today")}]`,
        nextDay: `[${this.$t("Tomorrow")}]`,
        nextWeek: "dddd",
        sameElse: "dddd"
      }
    }
  },
  watch: {
    isDirty(nval) {
      if (this._inactive) return
      if (nval) this.$store.dispatch("rss/fetchWeather").then(() => this.init(true))
    },
    day(nval, oval) {
      document.getElementById(`day${oval}`)?.classList.remove("activeElement")
    }
  },
  async activated() {
    if (!this.hasWeather) return this.$router.back()

    if (this.isDirty) await this.$store.dispatch("rss/fetchWeather")
    this.init()
  },
  methods: {
    async init(inside = false) {
      this.active = this.$route.params.city || 0
      this.focused(0)

      await this.$nextTick()

      if (inside) _$.vue.$emit("sidepane", false)
      if (this.hasOnlyOne) return _$.nav.sync("weather", true)

      _$.nav.sync("weather", inside)
      _$.nav.sync("weather-change", !inside)
      if (!inside) _$.sleep(500).then(() => this.citySelector())
    },
    async citySelector() {
      const categories = this.$store.state.rss.weathers.map((source, index) => {
        return {
          key: index + 1,
          value: source.name,
          selected: this.active === index
        }
      })
      const res = await this.$sidepane(
        this.$t("Cities"),
        this.$t("Please select the city where you want to view the weather forecast."),
        categories,
        "right"
      )

      if (res) this.active = res - 1

      await this.$nextTick()
      _$.nav.sync("weather", true)
    },
    focused(e) {
      if (!this.current) return false
      this.day = e.target ? parseInt(e.target.dataset.id) : e
      __.platform.background(this.current.image)

      this.$nextTick().then(() => document.getElementById(`day${this.day}`)?.classList.add("activeElement"))
    }
  }
}
</script>

<style lang="scss" scoped>
.weather {
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    align-items: center;
    padding-right: 3em;

    .header-wrapper {
      flex-grow: 1;
    }
    .change {
      height: 65px;
      width: 65px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      box-shadow: 0 0px 5px 2px rgba(0, 0, 0, 0.3);
    }
  }

  .content {
    .temp {
      font-size: 5em;
    }
  }

  .footer {
    display: flex;
    overflow: unset;

    .weathers {
      display: flex;
      flex-grow: 1;
      border-top: 1px solid rgba(255, 255, 255, 0.3);

      .day {
        flex-direction: column;
        display: flex;
        flex: 1;
        align-items: center;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        border-left: 1px solid rgba(0, 0, 0, 0.3);
        overflow: hidden;
        position: relative;

        &:last-child {
          border-right: 0 !important;
        }

        &:first-child {
          border-left: 0 !important;
        }

        .day-name {
          padding: 5px 10px;
          width: 50%;
          text-align: center;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          text-transform: capitalize;
        }
        .day-icon {
          display: flex;
          align-items: center;
          flex-grow: 1;
        }
        .day-degrees {
          display: flex;
          align-items: center;
        }
        &.activeElement {
          background: #000;
        }

        &.nv-el-current,
        &.activeElement {
          border-top: 2px solid rgba(255, 255, 255, 0.3);
          margin: -50px -20px 0 -20px;
          border-radius: 20px;
          border-right: 0 !important;
          border-left: 0 !important;
          box-shadow: 0 5px 10px 2px rgba(0, 0, 0, 0.3);
          z-index: 1;
          position: relative;
          padding-bottom: 20px;

          .imagec {
            display: block;
            z-index: -1;
          }

          .max {
            font-size: 2em !important;
          }
          .min {
            font-size: 1.5em !important;
          }
        }

        .imagec {
          position: absolute !important;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: none;
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
